// DLC_09 · e-Doręczenia — drobne elementy wspólne dla ekranów modułu.
import { clsx } from "clsx";
import type { HubLink } from "@/features/power_projects/components/ui";
import type { IncomingStatus, OutgoingStatus } from "../types";

// Zakładki modułu. Skrzynka odbiorcza i konfiguracja są tylko dla CEO — bramka jest
// dodatkowo po stronie API, tu chodzi o to, żeby nie pokazywać drzwi, których nie otworzysz.
export const DLC09_HUB_LINKS: HubLink[] = [
  { to: "/edoreczenia", label: "Kolejka wysyłki", end: true },
  { to: "/edoreczenia/skrzynka", label: "Skrzynka odbiorcza", gate: (u) => !!u?.is_ceo },
  { to: "/edoreczenia/skrzynki", label: "Skrzynki i certyfikaty", gate: (u) => !!u?.is_ceo },
];

const OUTGOING_STYLE: Record<OutgoingStatus, string> = {
  queued: "bg-amber-100 text-amber-700 border-amber-300",
  approved: "bg-blue-100 text-blue-700 border-blue-300",
  rejected: "bg-[var(--color-primary-dim)] text-[var(--color-primary)] border-[var(--color-primary)]",
  sending: "bg-sky-100 text-sky-700 border-sky-300",
  sent: "bg-teal-100 text-teal-700 border-teal-300",
  delivered: "bg-emerald-100 text-emerald-700 border-emerald-300",
  failed: "bg-red-100 text-red-700 border-red-300",
  cancelled: "bg-[var(--color-bg-elevated)] text-[var(--color-text-muted)] border-[var(--color-border)]",
  withdrawn: "bg-[var(--color-bg-elevated)] text-[var(--color-text-muted)] border-[var(--color-border)]",
};

const INCOMING_STYLE: Record<IncomingStatus, string> = {
  new: "bg-amber-100 text-amber-700 border-amber-300",
  fetched: "bg-blue-100 text-blue-700 border-blue-300",
  filed: "bg-emerald-100 text-emerald-700 border-emerald-300",
  external: "bg-[var(--color-bg-elevated)] text-[var(--color-text-muted)] border-[var(--color-border)]",
};

export function StatusChip({
  label,
  status,
  kind,
}: {
  label: string;
  status: OutgoingStatus | IncomingStatus;
  kind: "outgoing" | "incoming";
}) {
  const style =
    kind === "outgoing"
      ? OUTGOING_STYLE[status as OutgoingStatus]
      : INCOMING_STYLE[status as IncomingStatus];
  return (
    <span
      className={clsx(
        "inline-block border px-1.5 py-0.5 text-[10px] font-bold font-mono uppercase tracking-wider",
        style,
      )}
    >
      {label}
    </span>
  );
}

export function formatBytes(bytes: number | null): string {
  if (!bytes) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} kB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
